// Production environment skeleton.
// Client-specific values (serverUrl, event dates, texts, form fields, etc.) are
// loaded at runtime from assets/config.json + assets/clients/{client}.json
// by RuntimeConfigService (APP_INITIALIZER) before any component renders.
// Only production and version are compile-time constants.

import { env } from './.env';

export const environment = {
  production: true,
  version: env['npm_package_version'],

  // Static — same for every client/deployment
  defaultLanguage: 'en-EN',
  supportedLanguages: ['en-EN'] as string[],

  // -------------------------------------------------------------------------
  // Everything below is populated at runtime by RuntimeConfigService.
  // Defaults here are intentionally empty/false so that TypeScript is happy
  // at compile time. These values are NEVER seen in the browser because
  // APP_INITIALIZER overwrites them before any component is constructed.
  // -------------------------------------------------------------------------

  client: '' as string,
  api_key: '' as string,

  serverUrl: '' as string,
  eplusSystem: '' as string,

  day_1: '' as string,
  day_2: '' as string,

  show_logistics_columns: false,

  visitor_show_terms: false,
  visitor_show_dsgvo: false,
  visitor_show_storno: false,
  visitor_show_media: false,
  visitor_show_haftung: false,

  exhibitor_show_terms: false,
  exhibitor_show_dsgvo: false,
  exhibitor_show_storno: false,
  exhibitor_show_media: false,

  taxid_required: false,
  show_accounting_info: false,

  linkMedia: '' as string,
  linkTerms: '' as string,
  linkDSGVO: '' as string,
  linkStorno: '' as string,
  linkHaftungsfreistellung: '' as string,
  brand_logo: '' as string,

  event_year: '' as string,
  veranstalter: '' as string,
  hotel_info: '' as string,
  hotel_parking: '' as string,
  event_space: '' as string,
  event_date: '' as string,
  book_night: '' as string,
  cancel_date: '' as string,
  event_dates: '' as string,
  veranstaltungs_land: '' as string,
  county_selection: false,

  termsListA: [] as string[],
  termsListB: [] as string[],

  // Deployment state — also overridden at runtime from assets/config.json
  event_finish: false,
  show_gallery: false,
  showGalleryAlways: false,
  show_teaser: false,
  teaser_html: '' as string,
  teaser_date: '' as string,

  arrival_day_before_date: '' as string,
  lunch_dates: [] as string[],
  nimes_visit_label: '' as string,
  inforeisen_trips: [] as string[],
  inforeisen_pdfs: [] as string[],

  video_source_dash: '' as string,
  video_source_webm: '' as string,
  video_source_mp4: '' as string,

  txt_EventName: '' as string,
  txt_Subline: '' as string,
  txt_Event_Domain: '' as string,
  txt_Welcome: '' as string,
  txt_Welcome_Text: '' as string,
  txt_Event_City: '' as string,
  txt_Hotel_Night: '' as string,
  txt_gallery_location: '' as string,

  add_exhibitor_stammdaten: {} as Record<string, any>,
  add_exhibitor_bewegungsdaten: {
    passport: '',
    linkedin: '',
    birthdate: '',
    hashtag: '',
    allergies: '',
    nahrungsmittelunvertraglichkeit: '',
    membership_level: '',
    comm_log: '',
    langulage_guide: '',
    image_videos: '',
    zielgruppe_angebote: '',
    arrival: {
      type_anreise: '',
      departure_location: '',
      arrival_departure_time: '',
      arrival_time: '',
      arrival_plane_selber: false,
      arrival_plane_atout: false,
      parking_space: false,
      arrival_day_before: false,
    },
    departure: {
      departure_type_departure: '',
      departure_time: '',
      departure_plane_selber: false,
    },
    post_event: {
      participate: 0,
      haftungsfreistellung: false,
      link_form: '',
    },
    event: {
      lunch1: false,
      lunch2: false,
      lunch3: false,
      nimes_visit: false,
    },
  },

  add_visitor_stammdaten: {} as Record<string, any>,
  add_visitor_bewegungsdaten: {
    passport: '',
    linkedin: '',
    birthdate: '',
    hashtag: '',
    allergies: '',
    nahrungsmittelunvertraglichkeit: '',
    membership_level: '',
    comm_log: '',
    langulage_guide: '',
    image_videos: '',
    zielgruppe_angebote: '',
    arrival: {
      type_anreise: '',
      departure_location: '',
      arrival_departure_time: '',
      arrival_time: '',
      arrival_plane_selber: false,
      arrival_plane_atout: false,
      parking_space: false,
      arrival_day_before: false,
    },
    departure: {
      departure_type_departure: '',
      departure_time: '',
      departure_plane_selber: false,
    },
    post_event: {
      participate: 0,
      haftungsfreistellung: false,
      link_form: '',
      join_inforeise: false,
      inforeise_rank1: '',
      inforeise_rank2: '',
      inforeise_rank3: '',
    },
    event: {
      lunch1: false,
      lunch2: false,
      lunch3: false,
    },
  },

  show_dyn_identity: [] as boolean[],
  caption_dyn_identity: {
    carrental: '',
    aircarrier: '',
    seacarrier: '',
    roadcarrier: '',
    railcarrier: '',
  },
  show_dyn_programming: [] as boolean[],
  caption_dyn_programming: {
    spicardy: '',
    spoitou: '',
    srhonealps: '',
    sfrenchriviera: '',
  },
  show_dyn_products: [] as boolean[],
  caption_dyn_products: {
    pobusiness: '',
    poreligious: '',
    poyouth: '',
    posummer: '',
    paquitaine: '',
    plorraine: '',
    pmidi: '',
    ppicardy: '',
  },
  show_dyn_regions: [] as boolean[],
  caption_dyn_regions: {
    ppoitou: '',
    prhonealps: '',
    pfrenchriviera: '',
    salsace: '',
  },
  show_dyn_productsreq: [] as boolean[],
  caption_dyn_productsreq: {
    k2starhotel: '',
    k3starhotel: '',
    k4starhotel: '',
    kleisure: '',
    kshow: '',
    saquitaine: '',
    slorraine: '',
    smidi: '',
    allergies: '',
  },

  show_dyn_regions_ex: [] as boolean[],
  caption_dyn_regions_ex: {
    alsace: '',
    limousin: '',
    lorraine: '',
    midipyrenes: '',
    poitoucharentes: '',
  },
  show_dyn_activities_ex: [] as boolean[],
  caption_dyn_activities_ex: {
    rhonealpes: '',
    riveria: '',
    monaco: '',
    thaiti: '',
    luxury: '',
  },

  EVENT_CATEGORIES: [] as string[],

  // Editable consent texts (Legal tab), loaded at boot from GET /public-legal.
  legal: {} as { [role: string]: { [type: string]: { [lang: string]: string } } },
  legalLanguages: {} as { [role: string]: string },
};
